import { getItem } from "../utils/localStorage.js"

const useGetLocalItem = (itemName) => {
  const { localItem } = getItem(itemName)

  return localItem ? localItem : {}
}

export default useGetLocalItem